import React from 'react'
import './Footer.scss'
import { Link } from "react-router-dom"
import igImg from '../../images/instagram.png'
import fbImg from '../../images/facebook.png'
import wpImg from '../../images/whatsapp.png'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footer-wraper">
                <div className="footer-container">
                    <div style={{width:"110px"}}>
                        <h3>Get to know us</h3>
                        <Link to="/"><p>Home</p></Link>
                        <Link to="/about"><p>About us</p></Link>
                        <Link to="/projects"><p>Projects</p></Link>
                        <Link to="/gallery"><p>Gallery</p></Link>
                        <Link to="/contactus"><p>Contact us</p></Link>
                    </div>
                    <div className='second-div'>
                        <h3>Address</h3>
                        <p>48/836,<br /> Near Felican pet hospital, <br /> Eroor,Vyttila</p>
                        <p>Pincode: 682306</p>
                        <div><a href='mailto:info@rtarcades.com'>info@rtarcades.com</a></div>
                        <a href='tel:+91 6238137553'>+91 6238137553 </a><br />
                        <a href='tel:+91 8921380418'>+91 8921380418</a>
                    </div>
                    <div>
                        <h3>Services</h3>
                        <p>- Turnkey Construction </p>
                        <p>- Building Permit</p>
                        <p>- 3D Designing</p>
                        <p>- Estimation</p>
                        <p>- Project Management</p>
                    </div>
                    <div className='last-one'>
                        <h3>Social Media</h3>
                        <div className='social-media'>
                            <a href="https://instagram.com/rtarcades?igshid=YmMyMTA2M2Y="><img src={igImg} alt="" /></a>
                            <a href="https://wa.me/+916238137553"><img src={wpImg} alt="" /></a>
                            <a href="https://www.facebook.com/rtarcades/"><img src={fbImg} alt="" /></a>
                        </div>
                    </div>
                </div>
            </div>
            <span>©copyright 2022 rt arcades. All rights reserved.</span>
        </div>
    )
}

export default Footer